export const anonAddress = (address: string) => {
  const regexSelectAllExceptWhiteSpaces = /[^\s]/g;
  return address.replaceAll(regexSelectAllExceptWhiteSpaces, '*')
}
